// hooks/useCasesHydration.ts — hydrate moderation cases above BOTH layouts.
//
// /council is a BareLayout route (not under ShellLayout) but reads the same caseStore,
// so cases must hydrate at the router root and re-fetch on each auth transition
// (guest → full, signout → redacted public projection).

import { useEffect } from 'react';
import { useSession } from '@/hooks';
import { casesService } from '@/core/services/casesService';

export function useCasesHydration(): void {
  const { isAuthenticated } = useSession();
  useEffect(() => {
    void casesService.listCases().catch(() => {});
  }, [isAuthenticated]);
}
